'use strict';

var generatedCraftcms = require('@liquorice/generated-craftcms');

const FIELD_FRAGMENT = generatedCraftcms.gql(`
  fragment field on FieldInterface {
    __typename
    id
    handle
    conditions
    enableConditions
    ...fieldBase
    ...fieldAddress
    ...fieldAgree
    ...fieldCheckboxes
    ...fieldDropdown
    ...fieldDate
    ...fieldName
    ...fieldRadio
    ...fieldFileUpload
    ...fieldNamePrefix
    ...fieldAddressCountry
    #
    ...fieldSection
    ...fieldHeading
  }
`);

exports.FIELD_FRAGMENT = FIELD_FRAGMENT;
